module.exports = __webpack_public_path__ + "img/home-oval-up.de422183.png";